module.exports = __webpack_public_path__ + "img/oferta.73bbf542.png";